import { Component, effect, input } from "@angular/core";
import { EvCdkTooltipComponent } from "ev-cdk-tooltip";
import { IForeclosureDiscount } from "../key-info-physical-exposure/key-info-physical-exposure.component";
import { DecimalPipe } from "@angular/common";
import { OverlayModule } from '@angular/cdk/overlay';

@Component({
    selector: "key-info-foreclosure-discount",
    templateUrl: "./key-info-foreclosure-discount.component.html",
    styleUrl: "./key-info-foreclosure-discount.component.scss",
    imports: [EvCdkTooltipComponent, OverlayModule, DecimalPipe],
})
export class KeyInfoForeclosureDiscountComponent {
    foreclosureDiscount = input<IForeclosureDiscount>(null);
    scoreTooltipOpen: boolean = false;
    openScoreInformation() {
        this.scoreTooltipOpen = true;
    }
    closeScoreInformation() {
        this.scoreTooltipOpen = false;
    }
}
